import { Controlled_BooleanInput } from '../components/inputs/controlled/Controlled_BooleanInput';
import { useCreateAnother } from '../hooks/useCreateAnother';

export const CreateAnotherButton = () => {
    const [createAnother, setCreateAnother] = useCreateAnother();

    return (
        <Controlled_BooleanInput
            readOnly={false}
            nullable={false}
            value={createAnother}
            onChange={setCreateAnother}
            label={'Create Another'}
        />
    );
};
